import React from "react";
import { useTranslation } from "react-i18next";

import * as SC from "./ToggleVisualization.styled";

const ToggleVisualization = ({ isNewDataVisualization, setVisualization }) => {
  const { t } = useTranslation();

  return (
    <SC.ToggleWrapper>
      <div>{t("Old view")}</div>
      <SC.Toggle
        checked={isNewDataVisualization}
        onChange={setVisualization}
        isNewDataVisualization={isNewDataVisualization}
      />
      <div>{t("New view")}</div>
    </SC.ToggleWrapper>
  );
};
export default ToggleVisualization;
